import React from 'react'

import Button from "../../../gd-components/buttons/gd-button/gd-button-ui5-new"
import FormManager from "../../common/form-manager"

const debug = false
// const debug = "FormActions"

type Props = {
    form                    : FormManager,
    type?                   : string,
    submitButtonDefaultType?: string,       // set to 'primary' to make default submit always blue
    submitLabel?            : string,

    className?              : string,
    children?               : any,

    isPro?                  : boolean       // if set to True will check pro License
    hideActions?            : boolean,      // hide (no render) when form not ready for submit
    cancelButton?           : boolean,

    onCancelClick?          : any
}

// this component pretends to be submit button

export default class FormActions extends React.Component<Props,any> {

    static defaultProps = {
        isPro                   : false,

        submitLabel             : 'Submit',
        submitButtonDefaultType : 'on-white',

        cancelButton            : false,
        hideActions             : false
    }

    componentDidMount() {
        this.props.form && this.props.form.registerSubmitButton(this)
    }

    onSubmitClick = (e: any) => {
        if (this.props.isPro && !gd.company.license.isPro) {
            gd.modals.other.upgradeToPro()
            return false
        }

        if (this.props.type==='busy') {
            e.preventDefault()
        } else {
            //this.props.onClick(e);
            this.props.form.onSubmitClick.call(this.props.form)
        }
    }

    render() {
        // auto hide when form not changed
        if (this.props.hideActions && this.props.form && !this.props.form.isFormChanged && !this.props.form.isSubmitting) {
            return false
        }

        let submitBtnType = this.props.submitButtonDefaultType

        if (this.props.form.isSubmitting) {
            submitBtnType = "busy"
        } else if (this.props.form.isFormValid && this.props.form.isFormChanged) {
            submitBtnType = "primary"
        }

        // icon={this.props.icon} - submit icon ???

        debug && console.log(debug,".render() TYPE=",submitBtnType," formIsSubmitting=",this.props.form.isSubmitting," formIsValid=",this.props.form.isFormValid," formIsChanged=",this.props.form.isFormChanged)

        return (
            <div className={Classes("actions", this.props.className)}>
                <Button onClick     = {this.onSubmitClick}
                        size        = '36'
                        type        = {submitBtnType}
                        label       = {this.props.submitLabel}
                        className   = 'btn-submit' />

                {this.props.isPro && !gd.company.license.isPro &&
                    <div className="ui5-ico-pro s-28 m-l-5" style={{marginTop: "-10px"}}/>}

                {this.props.cancelButton &&
                    <Button type="normal" label="Cancel" onClick={this.props.onCancelClick} className="btn-cancel"/>}

                {this.props.children}
            </div>
        )
    }
}